import $ from 'jquery'

export const appendElementByRelation = (element, position) => {
  const { type, selector } = position
  const reference = $(
    Array.isArray(selector) ? selector.find(s => $(s).length) : selector
  ).first()

  const htmlElement = $(element)

  switch (type) {
    case 'sibling':
      htmlElement.insertAfter(reference)
      break
    case 'insertBefore':
      htmlElement.insertBefore(reference)
      break
    default:
      reference.prepend(htmlElement)
      break
  }
}
